import { render, staticRenderFns } from "./WhitelistAlerts.vue?vue&type=template&id=3799f860&"
import script from "./WhitelistAlerts.vue?vue&type=script&lang=js&"
export * from "./WhitelistAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports